import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b2d5a83"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "w-7" }

import { listVideoResolution } from '@/data/video'
import { useDeviceStore } from '@/stores'

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoQualitySetting',
  setup(__props) {

const device = useDeviceStore()

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listVideoResolution), (resolution, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: `listVideoResolution-${index}`,
      class: "flex p-4 text-base cursor-pointer hover:bg-gray-100 duration-300 text-color",
      onClick: ($event: any) => (_unref(device).setSelectedVideoQuality(resolution))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (resolution === _unref(device).resolution)
          ? (_openBlock(), _createBlock(_component_SvgIcon, {
              key: 0,
              icon: "done",
              "inherit-fill": true,
              height: "20"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", null, _toDisplayString(resolution), 1)
    ], 8, _hoisted_1))
  }), 128))
}
}

})